import DonationDescription from '@/core/components/DonationDetails/DonationDescription/DonationDescription';

export default DonationDescription;
